import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { addUserProfile, getUserProfile, updateUserProfile } from "../repositories/user-profile/userProfileRepository"
import { USER_PROFILE } from "../constants/query.constants"
export const useUserProfile =()=>{
    return useQuery({
        queryKey:  [USER_PROFILE],
        queryFn:  getUserProfile
    });
}
export const useAddUserProfile  =()=>{
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn:  addUserProfile,
        onSuccess:()=>{
         queryClient.invalidateQueries([USER_PROFILE]);
        },
    });
}
export const useUpdateUserProfile =()=>{
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn:  updateUserProfile,
        onSuccess:()=>{
         queryClient.invalidateQueries([USER_PROFILE]);
        },
    });
}
